import React, { useState } from "react";
import { Button, Flex, Upload } from "antd";
import { DeleteOutlined, ExpandOutlined, UploadOutlined } from "@ant-design/icons";

import ImageCropper from "./ImageCropper";

export default function ImageField({ field, value, onChange, labels = {} }) {
  const [rawFile, setRawFile] = useState(null);
  const isFile = typeof File !== "undefined" && value instanceof File;
  const url = isFile ? URL.createObjectURL(value) : typeof value === "string" && value ? value : null;

  return (
    <Flex vertical gap="small" align="flex-start">
      {url && <img src={url} alt="" className="pt-image-preview" />}
      <Flex gap="small" wrap>
        {/* `beforeUpload: false` keeps the file local: nothing is uploaded here — the record's
            save does it, and only after the crop, which is mandatory. */}
        <Upload
          accept="image/*"
          maxCount={1}
          showUploadList={false}
          beforeUpload={file => {
            setRawFile(file);
            return false;
          }}>
          <Button icon={<UploadOutlined />}>{labels.pickImage}</Button>
        </Upload>
        {isFile && (
          <Button icon={<ExpandOutlined />} onClick={() => setRawFile(value)}>
            {labels.crop}
          </Button>
        )}
        {url && (
          <Button danger icon={<DeleteOutlined />} onClick={() => onChange(field.name, "")}>
            {labels.removeImage}
          </Button>
        )}
      </Flex>
      {rawFile && (
        <ImageCropper
          file={rawFile}
          labels={labels}
          onConfirm={cropped => {
            onChange(field.name, cropped);
            setRawFile(null);
          }}
          onCancel={() => {
            // Cropping is mandatory: cancelling discards the pick and leaves the current value
            // unchanged — an uncropped file is never uploaded.
            setRawFile(null);
          }}
        />
      )}
    </Flex>
  );
}
